import { motion } from "framer-motion";
import { ListMusic, ExternalLink } from "lucide-react";

const platformLinks = [
  { key: "spotify_url", label: "Spotify" },
  { key: "apple_url", label: "Apple Music" },
  { key: "youtube_url", label: "YouTube Music" },
];

export const Playlists = ({ playlists }) => (
  <section id="playlists" className="relative py-28 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="mb-14">
        <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00ff66] uppercase mb-3">// Official Playlists</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold uppercase text-white">The Entire Production,<br />On Your Platform</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        {playlists.map((p, i) => (
          <motion.div
            key={p.id}
            data-testid={`playlist-card-${i}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
            className="group bg-[#0c0c12] p-8 hover:bg-[#101018] transition-colors flex flex-col justify-between gap-8"
          >
            <div>
              <div className="flex items-center justify-between mb-5">
                <ListMusic size={24} className="text-[#00ff66]" strokeWidth={1.5} />
                <span className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-slate-500">{p.track_count} tracks</span>
              </div>
              <h3 className="font-display text-xl font-bold text-white uppercase group-hover:text-[#00ff66] transition-colors">{p.name}</h3>
              <p className="text-sm text-slate-400 mt-2 leading-relaxed">{p.description}</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {platformLinks.map((pl) => (
                <a
                  key={pl.key}
                  data-testid={`playlist-${i}-${pl.key}`}
                  href={p[pl.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 font-mono-tech text-[10px] tracking-wider uppercase px-3 py-2 border border-white/15 text-slate-400 hover:border-[#00ff66] hover:text-[#00ff66] transition-colors"
                >
                  {pl.label} <ExternalLink size={10} />
                </a>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
